import { Box, Button, Link, Paper, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { useT } from '../i18n';
import { config } from '../monetization/config';

const Q: React.FC<{ q: string; children: React.ReactNode }> = ({
    q,
    children,
}) => (
    <>
        <Typography variant="h6" component="h3" sx={{ mt: 2, fontWeight: 800 }}>
            {q}
        </Typography>
        <Typography paragraph>{children}</Typography>
    </>
);

/** Plain, readable page about the app and the technique: real content for visitors (and for ad review). */
export const AboutPage: React.FC = () => {
    const t = useT();
    return (
        <Box sx={{ height: '100%', overflowY: 'auto' }}>
            <Button component={RouterLink} to="/" sx={{ m: 1 }}>
                {t('app.backToTomato')}
            </Button>
            <Paper
                component="article"
                sx={{ maxWidth: 800, mx: 'auto', mb: 4, p: { xs: 2.5, sm: 4 } }}
            >
                <Typography variant="h4" component="h1" gutterBottom>
                    {t('about.title')}
                </Typography>
                <Typography paragraph>{t('about.intro')}</Typography>

                <Typography variant="h5" component="h2" sx={{ mt: 3 }}>
                    {t('about.whatTitle')}
                </Typography>
                <Typography paragraph>{t('about.what1')}</Typography>
                <Typography paragraph>{t('about.what2')}</Typography>

                <Typography variant="h5" component="h2" sx={{ mt: 3 }}>
                    {t('about.customTitle')}
                </Typography>
                <Typography component="ul" sx={{ pl: 3, mb: 2 }}>
                    <li>{t('about.custom1')}</li>
                    <li>{t('about.custom2')}</li>
                    <li>{t('about.custom3')}</li>
                    <li>{t('about.custom4')}</li>
                    <li>{t('about.custom5')}</li>
                </Typography>

                <Typography variant="h5" component="h2" sx={{ mt: 3 }}>
                    {t('about.tipsTitle')}
                </Typography>
                <Typography component="ul" sx={{ pl: 3, mb: 2 }}>
                    <li>{t('about.tip1')}</li>
                    <li>{t('about.tip2')}</li>
                    <li>{t('about.tip3')}</li>
                    <li>{t('about.tip4')}</li>
                    <li>{t('about.tip5')}</li>
                </Typography>

                <Typography variant="h5" component="h2" sx={{ mt: 3 }}>
                    {t('about.faqTitle')}
                </Typography>
                <Q q={t('about.q1')}>{t('about.a1')}</Q>
                <Q q={t('about.q2')}>{t('about.a2')}</Q>
                <Q q={t('about.q3')}>{t('about.a3')}</Q>
                <Q q={t('about.q4')}>
                    {t('about.a4a')}{' '}
                    <Link component={RouterLink} to="/privacy-policy">
                        {t('about.a4link')}
                    </Link>{' '}
                    {t('about.a4b')}
                </Q>
                <Q q={t('about.q5')}>
                    {t('about.a5')}{' '}
                    <Link href={`mailto:${config.supportEmail}`}>
                        {config.supportEmail}
                    </Link>
                    .
                </Q>
            </Paper>
        </Box>
    );
};
